// extracted by mini-css-extract-plugin
export var body = "member-module--body--njhsV";
export var component = "member-module--component--UTTBM";
export var controls = "member-module--controls--dXHNQ";
export var count = "member-module--count--I3FyI";
export var description = "member-module--description--MDhdu";
export var game = "member-module--game--eErLV";
export var hr = "member-module--hr--131Lu";
export var main = "member-module--main--rIgiR";
export var name = "member-module--name--F0KjI";
export var nav = "member-module--nav--6soWl";
export var next = "member-module--next--U77Ii";
export var position = "member-module--position--sQmVV";
export var previous = "member-module--previous--wVtAi";
export var side = "member-module--side--xATIY";
export var svg = "member-module--svg--j6IUH";